import axios from 'axios';
import { getAuth } from 'firebase/auth';

// CRA expõe REACT_APP_* em process.env
const DASHBOARD_BASE_URL = process.env.REACT_APP_DASHBOARD_API;

const api = axios.create({
  baseURL: DASHBOARD_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

async function withAuthHeader(config, { forceRefresh = false } = {}) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Missing token');

  const idToken = await user.getIdToken(forceRefresh);
  if (!idToken) throw new Error('Missing token');

  const headers = { ...(config.headers || {}), Authorization: `Bearer ${idToken}` };
  return { ...config, headers };
}

api.interceptors.request.use(
  async (config) => withAuthHeader(config),
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;

    if (status === 401 && !original.isRetry) {
      try {
        const retryBase = { ...original, isRetry: true };
        const retryConfig = await withAuthHeader(retryBase, { forceRefresh: true });
        return api.request(retryConfig);
      } catch (e) {
        // Melhorias feitas no fila e no em atendimentos
      }
    }

    return Promise.reject(error);
  }
);

const handleAxiosError = (error) => {
  if (error.response) {
    const message = error.response.data?.error || `Erro ${error.response.status}`;
    return new Error(message);
  }
  if (error.request) {
    return new Error('Sem resposta do servidor. Verifique sua conexão.');
  }
  return new Error(`Erro: ${error.message}`);
};

const apiGet = async (endpoint) => {
  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const getEstatisticasDashboard = () => apiGet('estatisticas');
export const getClientesNaoAtendidos = () => apiGet('/desistentes');
export const getClientesAtendidos = () => apiGet('/atendidos');
export const getEstatisticasEquipamentos = () =>
  apiGet('/estatisticas/equipamentos');

export default {
  getEstatisticasDashboard,
  getClientesNaoAtendidos,
  getClientesAtendidos,
  getEstatisticasEquipamentos,
};
